// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { fermentationId } from './Fermentation';
import { fermentationParameterTypeId } from './FermentationParameterType';
import { parameterSourceTypeEnum } from './ParameterSourceTypeEnum';
import { fermentationProtocolId } from './FermentationProtocol';
import { operatorId } from './Operator';
import { brewcontrolRunId } from './BrewcontrolRun';
import { fermentationLineTypeId } from './FermentationLineType';
import { brewcontrolEventId } from './BrewcontrolEvent';
import { fermentationChangesetId } from './FermentationChangeset';
import { z } from 'zod';
export const fermentationParameterId = (z.number());
export const fermentationParameter = z.object({
    id: fermentationParameterId,
    fermentation_id: fermentationId,
    parameter_type_id: fermentationParameterTypeId,
    effective_at: z.date(),
    number_value: z.string().nullable(),
    text_value: z.string().nullable(),
    checkbox_value: z.boolean().nullable(),
    source_type: parameterSourceTypeEnum,
    source_protocol_id: fermentationProtocolId.nullable(),
    reason: z.string().nullable(),
    operator_id: operatorId.nullable(),
    brewcontrol_run_id: brewcontrolRunId.nullable(),
    created_at: z.date(),
    created_by: operatorId.nullable(),
    deleted_at: z.date().nullable(),
    deleted_by: operatorId.nullable(),
    formula: z.string().nullable(),
    ramp_duration_h: z.string().nullable(),
    line_type_id: fermentationLineTypeId.nullable(),
    brewcontrol_event_id: brewcontrolEventId.nullable(),
    changeset_id: fermentationChangesetId.nullable(),
    entry_ordinal: z.number().nullable(),
    overrides_id: fermentationParameterId.nullable(),
});
export const fermentationParameterInitializer = z.object({
    id: fermentationParameterId.optional(),
    fermentation_id: fermentationId,
    parameter_type_id: fermentationParameterTypeId,
    effective_at: z.date(),
    number_value: z.string().optional().nullable(),
    text_value: z.string().optional().nullable(),
    checkbox_value: z.boolean().optional().nullable(),
    source_type: parameterSourceTypeEnum,
    source_protocol_id: fermentationProtocolId.optional().nullable(),
    reason: z.string().optional().nullable(),
    operator_id: operatorId.optional().nullable(),
    brewcontrol_run_id: brewcontrolRunId.optional().nullable(),
    created_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
    formula: z.string().optional().nullable(),
    ramp_duration_h: z.string().optional().nullable(),
    line_type_id: fermentationLineTypeId.optional().nullable(),
    brewcontrol_event_id: brewcontrolEventId.optional().nullable(),
    changeset_id: fermentationChangesetId.optional().nullable(),
    entry_ordinal: z.number().optional().nullable(),
    overrides_id: fermentationParameterId.optional().nullable(),
});
export const fermentationParameterMutator = z.object({
    id: fermentationParameterId.optional(),
    fermentation_id: fermentationId.optional(),
    parameter_type_id: fermentationParameterTypeId.optional(),
    effective_at: z.date().optional(),
    number_value: z.string().optional().nullable(),
    text_value: z.string().optional().nullable(),
    checkbox_value: z.boolean().optional().nullable(),
    source_type: parameterSourceTypeEnum.optional(),
    source_protocol_id: fermentationProtocolId.optional().nullable(),
    reason: z.string().optional().nullable(),
    operator_id: operatorId.optional().nullable(),
    brewcontrol_run_id: brewcontrolRunId.optional().nullable(),
    created_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
    formula: z.string().optional().nullable(),
    ramp_duration_h: z.string().optional().nullable(),
    line_type_id: fermentationLineTypeId.optional().nullable(),
    brewcontrol_event_id: brewcontrolEventId.optional().nullable(),
    changeset_id: fermentationChangesetId.optional().nullable(),
    entry_ordinal: z.number().optional().nullable(),
    overrides_id: fermentationParameterId.optional().nullable(),
});
//# sourceMappingURL=FermentationParameter.js.map